module.exports = __webpack_public_path__ + "img/zh-hk_get.9bbd17b.png";